/**
 * Проекты делятся на две группы:
 *  - собственные продукты, которые компания развивает сама;
 *  - работы, выполненные по заказу других компаний.
 */
export const ownProjects = [
  {
    slug: 'skillblocks',
    title: 'Skillblocks',
    summary:
      'Платформа для обучения с автоматической проверкой структуры и полноты курсов перед публикацией.',
    tags: ['Собственный продукт', 'Образование'],
    url: 'https://skillblocks.ru',
  },
];

export const clientProjects = [];

export const projectGroups = [
  {
    id: 'own',
    title: 'Собственные проекты',
    description: 'Продукты, которые мы разрабатываем и развиваем сами.',
    items: ownProjects,
  },
  {
    id: 'client',
    title: 'Проекты для заказчиков',
    description: 'Работы, выполненные по договору для других компаний.',
    items: clientProjects,
  },
];

export default ownProjects;
